import React, { useRef, useEffect } from 'react';
import { ArrowRight, ArrowLeft } from 'react-feather';
import SidebarMenuItems from './SidebarMenuItems';
import "./SidebarMenu.scss";

const SidebarMenu = ({ setMainMenu, props, sidebartoogle, setNavActive, activeClass }) => {
  const menuRef = useRef(null);

  const updateArrows = () => {
    const el = menuRef.current;
    if (!el) return;
    const atStart = el.scrollLeft <= 0;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    document.querySelector('.left-arrow')?.classList.toggle('d-none', atStart);
    document.querySelector('.right-arrow')?.classList.toggle('d-none', atEnd);
  };

  useEffect(() => {
    updateArrows();
    const timer = setTimeout(updateArrows, 400);
    window.addEventListener('resize', updateArrows);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateArrows);
    };
  }, []);

  const scrollToRight = () => {
    menuRef.current?.scrollBy({ left: 250, behavior: 'smooth' });
    setTimeout(updateArrows, 300);
  };

  const scrollToLeft = () => {
    menuRef.current?.scrollBy({ left: -250, behavior: 'smooth' });
    setTimeout(updateArrows, 300);
  };

  return (
    <nav className="sidebar-main" id="sidebar-main">
      <div className="left-arrow d-none" onClick={scrollToLeft}>
        <ArrowLeft />
      </div>
      <div id="sidebar-menu" className='lg:md-0'>
        <ul className="sidebar-links custom-scrollbar" ref={menuRef} onScroll={updateArrows}>
          <li className="back-btn">
            <div className="mobile-back text-end">
              <span>{'Back'}</span>
              <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
            </div>
          </li>
          <SidebarMenuItems setMainMenu={setMainMenu} props={props} sidebartoogle={sidebartoogle} setNavActive={setNavActive} activeClass={activeClass} />
        </ul>
      </div>
      <div className="right-arrow" onClick={scrollToRight}>
        <ArrowRight />
      </div>
    </nav>
  );
};

export default SidebarMenu;
